"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentType = void 0;
var TreatmentType;
(function (TreatmentType) {
    TreatmentType["UpgradeExistingFacilityToAnOnRoadBicycleLaneWithLightSegregation"] = "UpgradeExistingFacilityToAnOnRoadBicycleLaneWithLightSegregation";
    TreatmentType["UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane0To1m"] = "UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane0To1m";
    TreatmentType["UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane1To3m"] = "UpgradeExistingFacilityToAnOnRoadBicycleLaneWithSafetyBarrierAdjacentRoadLane1To3m";
    TreatmentType["UpgradeExistingFacilityToACyclingPriorityStreet"] = "UpgradeExistingFacilityToACyclingPriorityStreet";
    TreatmentType["UpgradeExistingFacilityToAMultiUsePath"] = "UpgradeExistingFacilityToAMultiUsePath";
    TreatmentType["UpgradeExistingFacilityToAnOffRoadBicyclePath"] = "UpgradeExistingFacilityToAnOffRoadBicyclePath";
    TreatmentType["UpgradeExistingFacilityToAOneWayBicycleFacility"] = "UpgradeExistingFacilityToAOneWayBicycleFacility";
    TreatmentType["ImproveSurfaceConditions"] = "ImproveSurfaceConditions";
    TreatmentType["InstallLightSegregation"] = "InstallLightSegregation";
    TreatmentType["InstallLighting"] = "InstallLighting";
    TreatmentType["ClearFacilityRemovedFixedObstacle"] = "ClearFacilityRemovedFixedObstacle";
    TreatmentType["ClearFacilityRemovedNonFixedObstacles"] = "ClearFacilityRemovedNonFixedObstacles";
    TreatmentType["ClearFacilityRemoveWidthRestriction"] = "ClearFacilityRemoveWidthRestriction";
    TreatmentType["ImproveFacilityAccess"] = "ImproveFacilityAccess";
    TreatmentType["RedesignTheCurve"] = "RedesignTheCurve";
    TreatmentType["WidenTheFacility"] = "WidenTheFacility";
    TreatmentType["InstallProtectiveBarrier"] = "InstallProtectiveBarrier";
    TreatmentType["ImproveDelineation"] = "ImproveDelineation";
    TreatmentType["ReviewIntersectionApproach"] = "ReviewIntersectionApproach";
    TreatmentType["ImproveSafetyOrCrossingDesign"] = "ImproveSafetyOrCrossingDesign";
    TreatmentType["EvaluateNeedForGradeSeparation"] = "EvaluateNeedForGradeSeparation";
    TreatmentType["ReconfigureOrRemoveParking"] = "ReconfigureOrRemoveParking";
    TreatmentType["ReviewConfigurationOfTrainTramRails"] = "ReviewConfigurationOfTrainTramRails";
    TreatmentType["InstallTrafficCalming"] = "InstallTrafficCalming";
    TreatmentType["VehiclesSpeedControl"] = "VehiclesSpeedControl";
    TreatmentType["BicyclesSpeedControl"] = "BicyclesSpeedControl";
})(TreatmentType || (exports.TreatmentType = TreatmentType = {}));
